import { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

/* ═══════════════════════════════════════════════════════════
   useDataTracker - 데이터 수집 훅
   페이지 조회, 클릭, 서비스 이용을 자동 트래킹
   ═══════════════════════════════════════════════════════════ */

const getDeviceType = () => {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
};

const sessionId = (() => {
  let sid = sessionStorage.getItem('_track_sid');
  if (!sid) {
    sid = Date.now().toString(36) + Math.random().toString(36).slice(2);
    sessionStorage.setItem('_track_sid', sid);
  }
  return sid;
})();

const send = (endpoint, data) => {
  try { api.post(`/data/${endpoint}`, data).catch(() => {}); } catch {}
};

export const trackEvent = (eventType, eventData = {}) => {
  send('track', {
    event_type: eventType,
    page_url: window.location.pathname,
    page_title: document.title,
    device_type: getDeviceType(),
    session_id: sessionId,
    referrer: document.referrer || null,
    event_data: eventData,
  });
};

export const trackService = (serviceType, detail = '', pointsUsed = 0, aiModel = null) => {
  send('track-service', {
    service_type: serviceType,
    service_detail: detail,
    points_used: pointsUsed,
    ai_model: aiModel,
  });
};

export const trackSearch = (query, resultCount = 0) => {
  send('track-search', {
    search_query: query,
    result_count: resultCount,
    search_type: 'general',
    device_type: getDeviceType(),
    session_id: sessionId,
  });
};

export const trackFunnel = (step) => {
  send('track-funnel', {
    step,
    session_id: sessionId,
    device_type: getDeviceType(),
  });
};

const useDataTracker = () => {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      const isFirst = prevPath.current === null;
      prevPath.current = location.pathname;
      trackEvent('page_view');
      // 메타 픽셀 / GA4 — SPA 라우트 변경 시 PageView 재발사.
      // 최초 진입은 index.html이 이미 PageView를 보내므로, 경로가 "바뀐" 다음부터만 보내 중복 집계를 막는다.
      if (!isFirst) {
        if (window.fbq) window.fbq('track', 'PageView');
        if (window.gtag) {
          window.gtag('event', 'page_view', {
            page_path: window.location.pathname + window.location.search,
            page_title: document.title,
          });
        }
      }
    }
  }, [location.pathname]);

  return { trackEvent, trackService, trackSearch, trackFunnel };
};

export default useDataTracker;
